// ========================= FRONTEND =========================
import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { InputNumber } from "primereact/inputnumber";
import { TabView, TabPanel } from "primereact/tabview";
import CatalogoCrud from "./CatalogCrud";
import * as XLSX from "xlsx";

const Inventario = () => {
  const [data, setData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [editando, setEditando] = useState(false);
  const [filters, setFilters] = useState({
    descripcion: "",
    id_ubicacion: null,
  });

  const [visibleImagen, setVisibleImagen] = useState(false);
  const [registroActual, setRegistroActual] = useState(null);
  const [imagen, setImagen] = useState(null);
  const [preview, setPreview] = useState(null);

  const axiosPrivate = useAxiosPrivate();
  const [form, setForm] = useState({
    id: null,
    num_inventario: "",
    descripcion: "",
    marca: "",
    modelo: "",
    serie: "",
    ubicacion: "",
    resguardante: "",
    cantidad: 1,
  });
  const initialForm = {
    num_inventario: "",
    descripcion: "",
    marca: "",
    modelo: "",
    serie: "",
    id_ubicacion: "",
    cantidad: 1,
    especificaciones: "",
    resguardante: "",
  };
  const fileInputRef = useRef(null);

  const [ubicaciones, setUbicaciones] = useState([]);
  const [resguardantes, setResguardantes] = useState([]);

  useEffect(() => {
    obtenerCatalogos();
  }, []);

  const obtenerCatalogos = async () => {
    const [u, r] = await Promise.all([
      axiosPrivate.get("/CEUM/inventario/ubicaciones"),
      axiosPrivate.get("/CEUM/inventario/resguardantes"),
    ]);

    setUbicaciones(u.data);
    setResguardantes(r.data);
  };

  const load = async () => {
    console.log("Cargando datos con filtros:", filters);
    const res = await axiosPrivate.get("CEUM/inventario", { params: filters });
    setData(res.data);
  };

  useEffect(() => {
    load();
  }, []);

  const guardar = async () => {
    if (editando) {
      await axiosPrivate.put(`CEUM/inventario/${form.id}`, form);
    } else {
      await axiosPrivate.post("CEUM/inventario", form);
    }

    setVisible(false);
    load();
  };

  const editar = (row) => {
    setForm(row);
    setEditando(true);
    setVisible(true);
  };
  const abrirDialogImagen = (row) => {
    setRegistroActual(row);
    setVisibleImagen(true);
    setImagen(null);
    setPreview(row.imagen_url || null); // si ya tiene imagen
  };

  const eliminar = async (row) => {
    await axiosPrivate.delete(`CEUM/inventario/${row.id}`);
    load();
  };
  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);

    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(sheet);

    console.log(jsonData);

    await axiosPrivate.post("/CEUM/inventario/importar", jsonData);
  };

  const subirImagen = async () => {
    const formData = new FormData();
    formData.append("imagen", imagen);
    formData.append("id", registroActual.id);
    console.log("Subiendo imagen para registro ID:", registroActual.id);
    console.log("FormData:", formData);
    // return;
    await axiosPrivate.post("/CEUM/inventario/upload", formData);

    setVisibleImagen(false);
    load(); // refrescar tabla para mostrar nueva imagen
    //cargarDatos(); // refrescar tabla
  };
  const eliminarImagen = async () => {
    if (!registroActual?.id) return;

    if (!window.confirm("¿Eliminar imagen?")) return;

    await axiosPrivate.delete(`/CEUM/inventario/imagen/${registroActual.id}`);

    setPreview(null);
    setImagen(null);

    load(); // refresca tabla
  };
  const [showCatalogos, setShowCatalogos] = useState(false);
  return (
    <div className="card">
      <div className="flex justify-content-between mb-3 mt-3">
        {/* <Button
          label="Nuevo"
          icon="pi pi-plus"
           onClick={nuevoRegistro}
        /> */}

        <Button
          icon="pi pi-cog"
          label="Administrar catálogos"
          className="p-button-secondary"
          onClick={() => setShowCatalogos(true)}
        />
      </div>
      {/* Filtros */}
      <div className="flex gap-2 mb-3">
        {/* <InputText
          placeholder="Descripción"
          onChange={(e) =>
            setFilters({ ...filters, descripcion: e.target.value })
          }
        /> */}
        <Dropdown
          value={filters.id_ubicacion}
          options={ubicaciones}
          optionLabel="nombre"
          optionValue="id"
          placeholder="Filtrar por ubicación"
          showClear
          onChange={(e) =>
            setFilters({ ...filters, id_ubicacion: e.value || null })
          }
        />
        <Button label="Filtrar" onClick={load} />
        <Button
          label="Nuevo"
          onClick={() => {
            setForm(initialForm);
            setEditando(false);
            setVisible(true);
          }}
        />
        <Button
          label="Importar Excel"
          icon="pi pi-upload"
          onClick={() => fileInputRef.current.click()}
        />

        <input
          type="file"
          accept=".xlsx, .xls"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFile}
        />
      </div>

      {/* Tabla tipo excel */}
      <DataTable value={data} paginator rows={10}>
        <Column field="num_inventario" header="#" />
        <Column field="descripcion" header="Descripción" />
        <Column field="marca" header="Marca" />
        <Column field="modelo" header="Modelo" />
        <Column field="serie" header="Serie" />
        <Column field="ubicacion" header="Ubicación" />
        <Column field="resguardante" header="Resguardante" />
        <Column field="cantidad" header="Cantidad" />
        <Column field="especificaciones" header="Especificaciones" />
        <Column
          header="Imagen"
          body={(row) =>
            row.imagen_url ? (
              <img src={row.imagen_url} width="50" alt="" />
            ) : (
              <div className="text-center text-gray-400">Sin imagen</div>
            )
          }
        />
        <Column
          body={(row) => (
            <>
              <div className="flex gap-2">
                <Button
                  icon="pi pi-image"
                  className="p-button-sm p-button-info"
                  onClick={() => abrirDialogImagen(row)}
                  tooltip="Subir imagen"
                />
                <Button icon="pi pi-pencil" onClick={() => editar(row)} />
                <Button icon="pi pi-trash" onClick={() => eliminar(row)} />
              </div>
            </>
          )}
        />
      </DataTable>

      {/* Modal */}
      <Dialog
        visible={visible}
        onHide={() => setVisible(false)}
        header="Inventario"
      >
        <div className="p-fluid grid">
          <div className="field col-12 md:col-6">
            <label>No. Inventario</label>
            <InputText
              value={form.num_inventario}
              onChange={(e) =>
                setForm({ ...form, num_inventario: e.target.value })
              }
            />
          </div>

          <div className="field col-12 md:col-6">
            <label>Descripción</label>
            <InputText
              value={form.descripcion}
              onChange={(e) =>
                setForm({ ...form, descripcion: e.target.value })
              }
            />
          </div>

          <div className="field col-12 md:col-6">
            <label>Marca</label>
            <InputText
              value={form.marca}
              onChange={(e) => setForm({ ...form, marca: e.target.value })}
            />
          </div>

          <div className="field col-12 md:col-6">
            <label>Modelo</label>
            <InputText
              value={form.modelo}
              onChange={(e) => setForm({ ...form, modelo: e.target.value })}
            />
          </div>

          <div className="field col-12 md:col-6">
            <label>Serie</label>
            <InputText
              value={form.serie}
              onChange={(e) => setForm({ ...form, serie: e.target.value })}
            />
          </div>

          {/* 🔥 Dropdown Ubicación */}
          <div className="field col-12 md:col-6">
            <label>Ubicación</label>
            <Dropdown
              value={form.id_ubicacion}
              options={ubicaciones}
              optionLabel="nombre"
              optionValue="id"
              placeholder="Selecciona ubicación"
              onChange={(e) => setForm({ ...form, id_ubicacion: e.value })}
            />
          </div>

          {/* 🔥 Dropdown Resguardante */}
          <div className="field col-12 md:col-6">
            <label>Resguardante</label>
            <Dropdown
              value={form.id_resguardante}
              options={resguardantes}
              optionLabel="nombre"
              optionValue="id"
              placeholder="Selecciona resguardante"
              onChange={(e) => setForm({ ...form, id_resguardante: e.value })}
            />
          </div>
          <div className="field col-12 md:col-6">
            <label>Cantidad</label>
            <InputNumber
              value={form.cantidad}
              onValueChange={(e) => setForm({ ...form, cantidad: e.value })}
              min={1}
            />
          </div>
          <div className="field col-12">
            <label>Especificaciones</label>
            <InputTextarea
              value={form.especificaciones}
              onChange={(e) =>
                setForm({ ...form, especificaciones: e.target.value })
              }
              rows={3}
            />
          </div>
        </div>
        <Button label="Guardar" onClick={guardar} />
      </Dialog>
      <Dialog
        header="Subir imagen"
        visible={visibleImagen}
        style={{ width: "30vw" }}
        onHide={() => setVisibleImagen(false)}
        modal
      >
        <div className="flex flex-column gap-3">
          {preview && (
            <img
              src={preview}
              alt="preview"
              style={{ width: "100%", borderRadius: "10px" }}
            />
          )}

          <input
            type="file"
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files[0];
              setImagen(file);
              setPreview(URL.createObjectURL(file));
            }}
          />

          <Button
            label="Subir"
            icon="pi pi-upload"
            onClick={subirImagen}
            disabled={!imagen}
          />
          {preview && (
            <Button
              label="Eliminar imagen"
              icon="pi pi-trash"
              className="p-button-danger"
              onClick={eliminarImagen}
            />
          )}
        </div>
      </Dialog>
      <Dialog
  header="Administrar Catálogos"
  visible={showCatalogos}
  style={{ width: "60vw" }}
  onHide={() => setShowCatalogos(false)}
>
  <TabView>
    <TabPanel header="Ubicaciones">
      <CatalogoCrud
        title="Ubicaciones"
        endpoint="/CEUM/inventario/ubicaciones"
        fields={[
          { name: "nombre", label: "Nombre" },
          { name: "descripcion", label: "Descripción" }
        ]}
      />
    </TabPanel>

    <TabPanel header="Resguardantes">
      <CatalogoCrud
        title="Resguardantes"
        endpoint="/CEUM/inventario/resguardantes"
        fields={[
          { name: "nombre", label: "Nombre" }
        ]}
      />
    </TabPanel>
  </TabView>
</Dialog>
    </div>
  );
};

export default Inventario;
